import {ReportFilterConstraintsEnum, UserRelationTypesEnum} from '@spa/api';

import {TradingGroupClientTypesEnum} from '../../app/entries/panel/enums/trading-group-client-types.enum';

/**
 * SES stores each subscription's client type as a `UserRelationTypesEnum` ordinal
 * (1 = Individual, 2 = CompanyEmployee, 4 = IndividualSubordinate). The Event History
 * "Client Type" filter is expressed with `TradingGroupClientTypesEnum` (Individual / Company),
 * so it must be translated into the matching relation ordinal(s) before being sent to SES:
 *   - Individual  -> In [1, 4]  (owner + subordinate individuals)
 *   - Company     -> Eq 2       (company employee)
 * Returns null when there is no client-type constraint to apply.
 */
export interface ClientTypeRelationConstraint {
    op: ReportFilterConstraintsEnum;
    value: string;
}

export const clientTypeToRelationConstraint = (clientType: number): ClientTypeRelationConstraint | null => {
    switch (clientType) {
        case TradingGroupClientTypesEnum.Individual:
            return {
                op: ReportFilterConstraintsEnum.In,
                value: [UserRelationTypesEnum.Individual, UserRelationTypesEnum.IndividualSubordinate].join(',')
            };
        case TradingGroupClientTypesEnum.Company:
            return {
                op: ReportFilterConstraintsEnum.Equal,
                value: UserRelationTypesEnum.CompanyEmployee.toString()
            };
        default:
            return null;
    }
};
